import isUrl from 'validator/lib/isURL';

const ACCEPT_INVITATION_REGEX = new RegExp('/accept-invitation/([^/]+)');
const MATCH_HANDSHAKE_REGEX = new RegExp('/handshake/([^/]+)');
const MATCH_PAGE_VIEW_MODE_REGEX = new RegExp("/sites/[0-9a-z]+/pages/([0-9a-z]+)/view/([a-z]+)");

export default class URLUtil {
  static isValidURL = (s, options = { }) => {
    return isUrl(s, options)
  }

  static hasQueryParams = (url) => {
    try {
      const urlObject = new URL(url);
      return urlObject.search.length > 0;
    } catch (error) {
      return false;
    }
  }

  static removeQueryParams = (url) => {
    try {
      const urlObject = new URL(url);
      return urlObject.origin + urlObject.pathname;
    } catch (error) {
      return url;
    }
  }

  static extractIdAfterSubdirectory = (subDirectory, pathname) => {
    const match = new RegExp(`/${subDirectory}/([0-9a-z]+)`).exec(pathname);
    return match && match[1] !== 'create' ? match[1] : '';
  }

  static matchAcceptInvitation = (pathname) => {
    return ACCEPT_INVITATION_REGEX.exec(pathname);
  }

  static matchHandshake = (pathname) => {
    return MATCH_HANDSHAKE_REGEX.exec(pathname);
  }

  static matchPageViewMode = (pathname) => {
    return MATCH_PAGE_VIEW_MODE_REGEX.exec(pathname);
  }

  static isInternalIpUrl = (url) => {
    try {
      const urlObject = new URL(url);
      return urlObject.hostname.startsWith('10.') || urlObject.hostname.startsWith('172.') || urlObject.hostname.startsWith('192.');
    } catch (error) {
      return false;
    }
  }

  static isNotInternalIpUrl = (url) => {
    return !this.isInternalIpUrl(url);
  }

  /**
   * Coerce a query-string value using the type of `defaultValue` as a hint.
   * Empty/missing values return `defaultValue`.
   *
   * @param {*} raw - Parsed query value (usually a string)
   * @param {*} defaultValue - Default used for type and fallback
   * @returns {*}
   */
  static coerceQueryValue = (raw, defaultValue) => {
    if (raw == null || raw === '') return defaultValue;

    if (typeof defaultValue === 'number') {
      const parsed = Number(raw);
      return Number.isFinite(parsed) ? parsed : defaultValue;
    }

    if (typeof defaultValue === 'boolean') {
      if (raw === true || raw === 'true') return true;
      if (raw === false || raw === 'false') return false;
      return defaultValue;
    }

    if (Array.isArray(defaultValue)) {
      return Array.isArray(raw) ? raw : String(raw).split(',').filter(Boolean);
    }

    return raw;
  }

  /**
   * Serialize an array for the query string as a comma-separated value.
   * Empty/non-arrays are omitted (`undefined`).
   *
   * @param {*} value
   * @returns {string|undefined}
   */
  static serializeQueryArray = (value) => (
    Array.isArray(value) && value.length ? value.join(',') : undefined
  )
}
